import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ModalTitle = styled.div`
  margin-bottom: 24px;

  .title {
    text-align: center;
    line-height: 130%;
    font-size: 18px;
    font-weight: 600;
  }

  @media ${({ theme }) => theme.media.smMax} {
    margin-bottom: ${mixin.pxToVw('24')};

    .title {
      font-size: ${mixin.pxToVw('18')};
    }
  }
`;
